import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './ProjectDetailsPage.css';

const ProjectDetailsPage = () => {
  const [isBookmarked, setIsBookmarked] = useState(false);

  const projectData = {
    type: 'Renovation',
    title: 'Revitalization of The Relic Site of Yongle Palace / URBANUS',
    companyName: 'Eiffage Construction',
    category: 'Cement',
    quantity: '1000 bg',
    area: 'Dubai',
    description: `Established in 2014, this family-run Italian restaurant is located in a high-footfall downtown area with consistent loyal customer traffic. Fully furnished, with a turnkey setup, trained staff, and high online ratings. Great opportunity for a hands-on operator or investor. Established in 2014, this family-run Italian restaurant is located in a high-footfall downtown area with consistent loyal customer traffic.`,
    mainImage: 'https://api.builder.io/api/v1/image/assets/TEMP/4b61fb9908c3fc0a62b18864aee8ce03d13e04fe?width=2104',
    thumbnails: [
      'https://api.builder.io/api/v1/image/assets/TEMP/aac384970d8208aa13ca1ff21eb67940d081ff3c?width=395',
      'https://api.builder.io/api/v1/image/assets/TEMP/aac384970d8208aa13ca1ff21eb67940d081ff3c?width=395',
      'https://api.builder.io/api/v1/image/assets/TEMP/aac384970d8208aa13ca1ff21eb67940d081ff3c?width=395',
      'https://api.builder.io/api/v1/image/assets/TEMP/2a082c64b6bb1af2a38c1dbef011eb1fb1520cdf?width=395',
      'https://api.builder.io/api/v1/image/assets/TEMP/6a32a53131ffd817fed4140b66d7908c860dd49e?width=395',
    ],
    extraImagesCount: 10,
  };

  const relatedProjects = [
    {
      id: 1,
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/dfa323de11035416a213de014e57d4696d14b816?width=568',
    },
    {
      id: 2,
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/f283a5e5107e7b4ba148f8fc1e14c07b9982929e?width=568',
    },
    {
      id: 3,
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/dfa323de11035416a213de014e57d4696d14b816?width=568',
    },
  ];

  const galleryImages = [
    'https://api.builder.io/api/v1/image/assets/TEMP/aac384970d8208aa13ca1ff21eb67940d081ff3c?width=395',
    'https://api.builder.io/api/v1/image/assets/TEMP/aac384970d8208aa13ca1ff21eb67940d081ff3c?width=395',
    'https://api.builder.io/api/v1/image/assets/TEMP/aac384970d8208aa13ca1ff21eb67940d081ff3c?width=395',
    'https://api.builder.io/api/v1/image/assets/TEMP/2a082c64b6bb1af2a38c1dbef011eb1fb1520cdf?width=395',
    'https://api.builder.io/api/v1/image/assets/TEMP/2a082c64b6bb1af2a38c1dbef011eb1fb1520cdf?width=395',
  ];

  return (
    <div className="project-details-page">
      <Header />
      
      <main className="project-details-content">
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/" className="breadcrumb-link">Home</Link>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 13L10 9L6 5" stroke="#505050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <Link to="/projects" className="breadcrumb-link">Project</Link>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 13L10 9L6 5" stroke="#505050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="breadcrumb-current">Project Details</span>
        </div>

        <div className="project-details-wrapper">
          {/* Main Content */}
          <div className="project-main-content">
            {/* Project Header */}
            <div className="project-header">
              <h1 className="project-type">{projectData.type}</h1>
              <p className="project-title">{projectData.title}</p>
            </div>

            {/* Main Image Section */}
            <div className="project-images-section">
              <div className="main-image-container">
                <img 
                  src={projectData.mainImage} 
                  alt="Project main" 
                  className="main-project-image"
                />
                <button 
                  className="bookmark-btn"
                  onClick={() => setIsBookmarked(!isBookmarked)}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect width="24" height="24" rx="4" fill="white" fillOpacity="0.7"/>
                    <path 
                      d="M17 3H6.5C6.10218 3 5.72064 3.15804 5.43934 3.43934C5.15804 3.72064 5 4.10218 5 4.5V21C5.00007 21.1338 5.03595 21.2652 5.10393 21.3805C5.17191 21.4958 5.2695 21.5908 5.38659 21.6557C5.50367 21.7206 5.63598 21.7529 5.76978 21.7494C5.90358 21.7458 6.034 21.7066 6.1475 21.6356L11.75 18.1341L17.3534 21.6356C17.4669 21.7063 17.5972 21.7454 17.7309 21.7488C17.8646 21.7522 17.9967 21.7198 18.1136 21.655C18.2306 21.5902 18.3281 21.4953 18.396 21.3801C18.4639 21.2649 18.4998 21.1337 18.5 21V4.5C18.5 4.10218 18.342 3.72064 18.0607 3.43934C17.7794 3.15804 17.3978 3 17 3ZM17 19.6472L12.1466 16.6144C12.0274 16.5399 11.8896 16.5004 11.7491 16.5004C11.6085 16.5004 11.4708 16.5399 11.3516 16.6144L6.5 19.6472V4.5H17V19.6472Z" 
                      fill={isBookmarked ? "#1F396C" : "#969696"}
                    />
                  </svg>
                </button>
              </div>

              {/* Thumbnails */}
              <div className="thumbnails-row">
                {projectData.thumbnails.slice(0, 4).map((thumb, index) => (
                  <div key={index} className="thumbnail-container">
                    <img src={thumb} alt={`Thumbnail ${index + 1}`} className="thumbnail-image" />
                  </div>
                ))}
                <div className="thumbnail-container extra-images">
                  <img 
                    src={projectData.thumbnails[4]} 
                    alt="More images" 
                    className="thumbnail-image"
                  />
                  <div className="extra-overlay">
                    <span className="extra-count">+{projectData.extraImagesCount}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Project Details Info */}
            <div className="project-info-section">
              <div className="info-row">
                <span className="info-label">Company Name</span>
                <span className="info-value company-link">:{projectData.companyName}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Category</span>
                <span className="info-value">:{projectData.category}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Quantity</span>
                <span className="info-value">:{projectData.quantity}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Area</span>
                <span className="info-value">:{projectData.area}</span>
              </div>
            </div>

            {/* Second Main Image */}
            <div className="project-images-section second-image-section">
              <div className="main-image-container">
                <img 
                  src={projectData.mainImage} 
                  alt="Project detail" 
                  className="main-project-image"
                />
              </div>
            </div>

            {/* Project Description */}
            <div className="project-description-section">
              <p className="project-description">{projectData.description}</p>
            </div>

            {/* Project Gallery */}
            <div className="project-gallery-section">
              <h2 className="gallery-title">Project Gallery</h2>
              
              {/* Gallery Row 1 */}
              <div className="gallery-row">
                {galleryImages.map((img, index) => (
                  <div key={index} className="gallery-item">
                    <img src={img} alt={`Gallery ${index + 1}`} className="gallery-image" />
                  </div>
                ))}
              </div>
              
              {/* Gallery Row 2 */}
              <div className="gallery-row">
                {galleryImages.map((img, index) => (
                  <div key={index + 5} className="gallery-item">
                    <img src={img} alt={`Gallery ${index + 6}`} className="gallery-image" />
                  </div>
                ))}
              </div>
              
              {/* Gallery Row 3 */}
              <div className="gallery-row">
                {galleryImages.map((img, index) => (
                  <div key={index + 10} className="gallery-item">
                    <img src={img} alt={`Gallery ${index + 11}`} className="gallery-image" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sidebar - Related Projects */}
          <aside className="project-sidebar">
            <h2 className="sidebar-title">Related Project</h2>
            <div className="related-projects">
              {relatedProjects.map((project) => (
                <div key={project.id} className="related-project-card">
                  <img 
                    src={project.image} 
                    alt={`Related project ${project.id}`} 
                    className="related-project-image"
                  />
                </div>
              ))}
            </div>
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ProjectDetailsPage;
